<ng-container *ngIf="gallery">
    <close-page></close-page>
    <page-title [title]="'Galeria i filmy'"></page-title>
    <!-- <media-list [title]="'Filmiki'" [type]="'video'"></media-list>
    <media-list [title]="'Zdjęcia'" [type]="'image'"></media-list> -->
    <ng-container *ngFor="let item of gallery">
        <media-list *ngIf="item.nameSet == 'gallery_videos'" [title]="'Filmiki'" [type]="'video'" [data]="item.gallery"></media-list>
        <media-list *ngIf="item.nameSet == 'gallery_images'" [title]="'Zdjęcia'" [type]="'image'" [data]="item.gallery"></media-list>
    </ng-container>
</ng-container>